import { render, staticRenderFns } from "./CategorySwiper.vue?vue&type=template&id=ed1b5072&scoped=true&"
import script from "./CategorySwiper.vue?vue&type=script&lang=js&"
export * from "./CategorySwiper.vue?vue&type=script&lang=js&"
import style0 from "./CategorySwiper.vue?vue&type=style&index=0&id=ed1b5072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1b5072",
  null
  
)

export default component.exports